/**
 * Created by mukund on 6/10/15.
 */
'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('playback', {
                parent: 'site',
                url: '/playback/:collectionType/:collectionId/:assetId',
                params: {
                    rootCollectionId: null,
                    rootPath: null
                },
                data: {
                    roles: [],
                    pageTitle: 'playback.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/playback/templates/playback.html',
                        controller: 'PlaybackController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('playback');
                        return $translate.refresh();
                    }]
                }
            });
    });
